const createRandomId = name =>
  `${name}--${new Date().getTime()}${Math.round(Math.random() * 1000)}`;

export default createRandomId;

